import type {
    ComposableOptionsBase,
    AttributeValue,
    BundleSwatchAttrs,
    BundleSwatchTitles,
    BundleSwatchData,
    BundleComponent
} from '~/types';
import { sortWithSortOrderAscFn } from 'x1-base/utils';

export interface UseBundleComponentsOptions extends ComposableOptionsBase {}
export function useBundleComponents(
    options: Partial<UseBundleComponentsOptions> = {}
) {

    function getBundleSwatchData(
        components: BundleComponent[]
    ): BundleSwatchData {
        const titles: BundleSwatchTitles = new Map();
        const attrs: BundleSwatchAttrs = new Map();

        components.forEach((cmp) => {
            const { name } = cmp;

            if (cmp.sku) {
                const {
                    productName,
                    productUid: id,
                    options: opts
                } = cmp.sku;
                const { qty } = cmp;

                const colorAttr = opts?.sort(sortWithSortOrderAscFn<AttributeValue>)
                    .find((attr) => !!attr.colors.length);

                if (colorAttr) {
                    const items = Array(qty).fill(colorAttr);
                    if (attrs.has(id!)) {

                        attrs.get(id!)!.push(...items);
                    } else {
                        titles.set(id!, name || productName!);
                        attrs.set(id!, items);
                    }
                }
            }
        });

        return { titles, attrs };
    }

    return {
        getBundleSwatchData
    };
}
